// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qb0vO","type":"styles_type__1YLyV","choices":"styles_choices__2wVkW"};